import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ContractingService } from 'src/app/shared/services/contracting.service';
import { ProgressSpinner } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CardModule,
        ButtonModule,
        OverlayPanelModule,
        ReactiveFormsModule,
        FormsModule,
        ProgressSpinner,
        CommonModule,
        InputTextModule
    ],
    selector: 'app-contracting-completed',
    templateUrl: './contracting-completed.component.html',
    styles: []
})
export class ContractingCompletedComponent {
  private contractService = inject( ContractingService );

  public op = computed(() => this.contractService.currentOperation() );

  public opDni = '';
  isValidDni = false;
  showLoading = false;
  timeout: any = null;

  public exit() {
    this.contractService.clearOp();
    return document.location.href = 'https://luxoro.es';
  }

  public validateDni():void {
    if(this.opDni === this.op()?.seller?.dni?.number) {
      this.isValidDni = true;
      return;
    } else {
      return;
    }
  }

  onKeySearch(event: any) {
    this.showLoading = true;
    this.isValidDni = false;
    clearTimeout(this.timeout);
    var $this = this;
    this.timeout = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.executeListing(event.target.value);
      }
    }, 1000);
  }

  private executeListing(value: string) {
    this.showLoading = true;
    if(this.opDni === this.op()?.seller?.dni?.number) {
      this.isValidDni = true;
      return;
    } else {
      return;
    }
  }

  downloadContract() {
    return window.open(this.op()?.contract?.pdf?.downloadUrl, '_blank');
  }

}
